import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { FormLabel } from '@mui/material';
import { FormGroup, FormControl } from '@mui/material';
import { InputLabel } from '@mui/material';
import  Select,{ SelectChangeEvent } from "@mui/material/Select";
import { MenuItem } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FormHelperText } from '@mui/material';
import { Button } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { sites,organs,modals } from '../../Environment/Config';

type ManagementFormsType = {
  title:string,
  PatientSex:string,
  PatientAge:string,
  PatientId:string,
  CatalogueId:string,
  site:string,
  share:string,
  siteTags:string[],
  organTags:string[],
  modality:string,
  diagnosis:string,
  findings:string,
  positiveFindings:string,
  originalFindings:string,
  originalDiagnosis:string,
  clinicalDiagnosis:string,
  originalClinicalDiagnosis:string,
  getContentsData:(array:boolean | string | string[],value:string) => void
  getTaglist:(value:string[],name:string) => void
}



export default function ManagementForms(props:ManagementFormsType) {
  
  const patientId:string = props.PatientId;
  const PatientSex:string = props.PatientSex;
  const PatientAge:string = props.PatientAge;
  const originalFindings:string = props.originalFindings;
  const originalClinicalDiagnosis:string = props.originalClinicalDiagnosis;
  const originalDiagnosis:string = props.originalDiagnosis;

  
  const [title, setTitle] = React.useState(props.title);  
  const [site, setSite] = React.useState(props.site);
  const [siteTags, setSiteTags] = React.useState<string[]>(props.siteTags);
  const [organTags, setOrganTags] = React.useState<string[]>(props.organTags);
  const [share,setShare] = React.useState(props.share);
  const [modality,setModality]= React.useState(props.modality);
  const [diagnosis, setDiagnosis] = React.useState(props.diagnosis);
  //const [TagInformation, setTagInformation] = React.useState(props.TagInformation);
  const [findings, setFindings] = React.useState(props.findings);
  const [positiveFindings,setPositiveFindings]= React.useState(props.positiveFindings);
  const [clinicalDiagnosis,setClinicalDiagnosis]= React.useState(props.clinicalDiagnosis);
  const [update, setUpdate] = React.useState(false);
  const [copied, setCopied] = React.useState(false);

  const shareUrl = `${window.location.host}/catalogue/d151f295-42db-f3b4-a456-d1ad2ac17f09/${props.CatalogueId}`

  
  const ChangeTags = (element:string, array:string[],name:string) => {
    if (array.includes(element)) {
      const found = array.findIndex(item => item === element);
      array.splice(found, 1)
    } else {
      array.push(element)
    }
    if(name==='site'){
      setSiteTags(array)
      props.getTaglist(array,'site')
    }else if(name==='organ'){
      setOrganTags(array)
      props.getTaglist(array,'organ')
    }
    setUpdate(update ? false : true)
  }
  


  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
  <div>
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          詳細情報入力
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} display={{sm:'flex',xs:'grid'}} gap={3}>
          <FormControl fullWidth>
              <TextField
              id="filled-read-only-input"
              label="ID"
              defaultValue={patientId}
              InputProps={{
                readOnly: true,
              }}
              variant="filled"
            />
             </FormControl>
            <TextField
              required
              id="title"
              name="title"
              label="タイトル"
              fullWidth
              defaultValue={title}
              autoComplete="given-name"
              variant="standard"
              onChange={
                (event) => {
                  setTitle(event.target.value)
                  props.getContentsData(event.target.value, 'title')
                }}
            />
          </Grid>
          <Grid item xs={12} sm={12} display={{sm:'flex',xs:'grid'}} gap={3}>
            <FormControl fullWidth>
              <TextField
              id="filled-read-only-input"
              label="年齢"
              defaultValue={parseInt(PatientAge)}
              InputProps={{
                readOnly: true,
              }}
              variant="filled"
            />
            </FormControl>
            <FormControl fullWidth variant="filled">
              <InputLabel id="demo-simple-select-label">Sex</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={PatientSex}
                label="Sex"
                inputProps={{ readOnly: true }}
              >
                <MenuItem value="1">男性</MenuItem>
                <MenuItem value="2">女性</MenuItem>
                <MenuItem value='unknown'>不明</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">共有</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={share}
                label="Sex"
                onChange={(event:SelectChangeEvent<string>) => {
                  setShare(event.target.value as string)
                  props.getContentsData(event.target.value as string, 'share')
                }}
              >
                <MenuItem value='true'>公開</MenuItem>
                <MenuItem value='url'>URLでの公開</MenuItem>
                <MenuItem value='mnist'>MNiST限定</MenuItem>
                <MenuItem value='false'>非公開</MenuItem>
              </Select>
            
              <div>
              { (share === 'url') || (share === 'mnist')?
                <Grid item xs={16} sx={{p:2}}>
              <CopyToClipboard text={shareUrl}
                                  onCopy={() => setCopied(true)}>
                                  <Button variant="contained">リンクコピー</Button>
                              </CopyToClipboard>
              </Grid>:<div></div>}
              </div>
            </FormControl>
          </Grid>
          <Grid item xs={16}>
            <TextField
            id="filled-read-only-input"
            label="部位"
            defaultValue={site}
            InputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
          </Grid>
         
          <Grid item xs={16}>
            <FormLabel component="legend" required>Modality</FormLabel>
            <FormGroup aria-label="position" row>
              {
                modals.map((element:string) => {
                  return (
                    <FormControlLabel
                      key={element}
                      control={<Checkbox disabled
                        checked={modality.includes(element) === true}
                      />}
                      label={element}
                      labelPlacement="end" />
                  )
                })}
            </FormGroup>
          </Grid>
          <Grid item xs={16}>
            <FormLabel component="legend" required>部位タグ</FormLabel>
            <FormGroup aria-label="position" row>
              {
                sites.map((element:string) => {
                  return (
                    <FormControlLabel
                      key={element}
                      control={<Checkbox 
                        checked={siteTags.includes(element) === true}
                        onChange={(event:React.ChangeEvent<HTMLInputElement>) => {
                          var oldData = siteTags
                          ChangeTags(element,oldData,'site')
                        }}
                      />}
                      label={element}
                      labelPlacement="end" />
                  )
                })}
            </FormGroup>
          </Grid>
          <Grid item xs={16}>
            <FormLabel component="legend" required>臓器タグ</FormLabel>
            <FormGroup aria-label="position" row>
              {
                organs.map((element:{name: string}) => {
                  return (
                    <FormControlLabel
                      key={element.name}
                      control={<Checkbox 
                        checked={organTags.includes(element.name) === true}
                        onChange={(event:React.ChangeEvent<HTMLInputElement>) => {
                          var oldData = organTags
                          ChangeTags(element.name,oldData,'organ')
                        }}
                      />}
                      label={element.name}
                      labelPlacement="end" />
                  )
                })}
            </FormGroup>
          </Grid>
          <Grid item xs={16}>
            <TextField
              id="address2"
              name="address2"
              label="症状経過等原本"
              fullWidth
              defaultValue={originalClinicalDiagnosis}
              autoComplete="shipping address-line2"
              variant="outlined"
              InputProps={{
                readOnly: true,
              }}
              multiline
              rows={3}
            />
          </Grid>
          <Grid item xs={16}>
            <TextField
              id="address2"
              name="address2"
              label="症状経過等"
              fullWidth
              defaultValue={clinicalDiagnosis}
              autoComplete="shipping address-line2"
              variant="standard"
              onChange={
                (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                  setClinicalDiagnosis(event.target.value as string)
                  props.getContentsData(event.target.value as string, 'clinicalDiagnosis')
                }}
              multiline
              rows={2}
            />
            <FormHelperText>患者情報を入力</FormHelperText>
          </Grid>
          <Grid item xs={16}>
            <TextField
              id="address2"
              name="address2"
              label="診断レポート原本"
              fullWidth
              defaultValue={originalFindings}
              autoComplete="shipping address-line2"
              variant="outlined"
              InputProps={{
                readOnly: true,
              }}
              multiline
              rows={10}
            />
          </Grid>
          <Grid item xs={16}>
            <TextField
              id="address2"
              name="address2"
              label="診断レポート"
              fullWidth
              defaultValue={findings}
              autoComplete="shipping address-line2"
              variant="standard"
              onChange={
                (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                  setFindings(event.target.value as string)
                  props.getContentsData(event.target.value as string, 'findings')
                }}
              multiline
              rows={10}
            />
            <FormHelperText>レポート内容を入力</FormHelperText>
          </Grid>
          <Grid item xs={16}>
            <TextField
              id="address2"
              name="address2"
              label="陽性所見"
              fullWidth
              defaultValue={positiveFindings}
              autoComplete="shipping address-line2"
              variant="outlined"
              onChange={
                (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                  setPositiveFindings(event.target.value as string)
                  props.getContentsData(event.target.value as string, 'positiveFindings')
                }}
              multiline
              rows={10}
            />
            <FormHelperText>陽性所見を入力</FormHelperText>
          </Grid>
          <Grid item xs={16}>
            <TextField
              id="address2"
              name="address2"
              label="診断原本"
              fullWidth
              defaultValue={originalDiagnosis}
              autoComplete="shipping address-line2"
              variant="outlined"
              InputProps={{
                readOnly: true,
              }}
              multiline
              rows={3}
            />
          </Grid>
          <Grid item xs={16}>
            <TextField
              id="address2"
              name="address2"
              label="診断"
              fullWidth
              defaultValue={diagnosis}
              autoComplete="shipping address-line2"
              variant="standard"
              onChange={
                (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                  setDiagnosis(event.target.value as string)
                  props.getContentsData(event.target.value as string, 'diagnosis')
                }}
              multiline
              rows={4}
            />
            <FormHelperText>この症例の診断を入力</FormHelperText>
          </Grid>
        </Grid>
      </React.Fragment>
    </div>
  );
}